import { useState } from 'react'

import { useDispatch } from 'react-redux'

import ApiError from '@/components/primitives/ApiError'
import { activatePopup } from '@/ducks/popupReducer'
import { get, post } from '@/util/auth'

const API_CALL_METHODS = {
  GET: 'GET',
  POST: 'POST',
}

// @ts-ignore
const getCallFnFromMethod = method => {
  switch (method) {
    case API_CALL_METHODS.POST:
      return post
    case API_CALL_METHODS.GET:
    default:
      return get
  }
}

// eslint-disable-next-line max-params
export const useApiCaller2 = (method: unknown, url: unknown, params = {}, props = {}) => {
  // @ts-ignore
  const { isErrorPopupActive = true } = props

  const dispatch = useDispatch()

  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()

  const callFn = getCallFnFromMethod(method)

  const callApi = async () => {
    setIsLoading(true)

    try {
      const route = Object.keys(params).reduce(
        // @ts-ignore
        (acc, cur) => acc.replace(`:${cur}`, params[cur]),
        url
      )
      // @ts-ignore
      return await callFn(route, params)
    } catch (error) {
      setError(error)
      // @ts-ignore
      isErrorPopupActive && dispatch(activatePopup(<ApiError error={error} />))
      return Promise.reject(error)
    } finally {
      setIsLoading(false)
    }
  }

  return {
    callApi,
    isLoading,
    error,
  }
}
// @ts-ignore
export const useApiCallerPOST = (url, params, props) =>
  useApiCaller2(API_CALL_METHODS.POST, url, params, props)
// @ts-ignore
export const useApiCallerGET = (url, params, props) =>
  useApiCaller2(API_CALL_METHODS.GET, url, params, props)
